import { isPlatformBrowser, NgIf, NgTemplateOutlet, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import {
  FormErrorComponent,
  FormInputComponent,
  FormInputDirective,
  FormLabelDirective,
  SvgComponent,
} from '@app/base-components';
import { contactFormUrl } from '@app/helpers';
import { SeoService } from '@app/services';
import { I18nModule, PageRobotsMeta } from 'haba-core';
import { MyOrdersDetailsComponent } from '../../user/my-orders-details/my-orders-details.component';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss'],
  imports: [
    NgIf,
    NgTemplateOutlet,
    MyOrdersDetailsComponent,
    ReactiveFormsModule,
    FormInputComponent,
    FormLabelDirective,
    FormInputDirective,
    FormErrorComponent,
    SvgComponent,
    I18nModule,
    NgClass,
    RouterModule,
  ],
})
export class OrderStatusComponent implements OnInit {
  readonly contactFormUrl = contactFormUrl;
  @Input() newTab: boolean;

  s4CustomerNumber: string;
  s4OrderNumber: string;
  isBrowser: boolean;

  public orderStatusGroup: FormGroup = this.fb.group({
    customerNr: ['', [Validators.pattern(/^\d{1,10}$/), Validators.required]],
    orderNr: ['', [Validators.pattern(/^9\d{9}$/), Validators.required]],
  });

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    protected fb: FormBuilder,
    private seoService: SeoService,
    protected cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.seoService.setSeoMetaData(
      'Bestellstatus',
      'Bestellstatus',
      PageRobotsMeta.NOINDEX,
      PageRobotsMeta.FOLLOW
    );

    this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
      this.s4CustomerNumber = queryParams.s4CustomerNumber;
      this.s4OrderNumber = queryParams.s4OrderNumber;
      this.newTab = !this.s4CustomerNumber || !this.s4OrderNumber;
      this.cdr.detectChanges();
    });
  }

  getOrderStatus() {
    const customerNr = this.orderStatusGroup.get('customerNr')?.value;
    const orderNr = this.orderStatusGroup.get('orderNr')?.value;

    this.router.navigate(['/bestellstatus'], {
      queryParams: { s4CustomerNumber: customerNr, s4OrderNumber: orderNr },
    });

    this.cdr.detectChanges();
  }

  validateInputLength(event: Event, maxLength: number): void {
    const input = event.target as HTMLInputElement;
    const fieldName = input.getAttribute('formControlName');

    if (fieldName === 'customerNr') {
      input.value = input.value.replace(/^0+/, '');
    }

    if (input.value && input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
      this.orderStatusGroup.get(fieldName)?.setValue(input.value);
    }
  }

  preventInvalidNumericChars(event: KeyboardEvent): void {
    if (
      event.key === '+' ||
      event.key === '-' ||
      event.key === 'e' ||
      event.key === 'E' ||
      event.key === '.'
    ) {
      event.preventDefault();
    }
  }

  getOrderNumberCriterionClass(criterionType: string): string | null {
    const orderNrControl = this.orderStatusGroup.get('orderNr');
    const value = orderNrControl?.value?.toString() || '';

    if (orderNrControl?.pristine) {
      return null;
    }

    switch (criterionType) {
      case 'startsWithNineAndTenDigits': {
        const isValid = /^9\d{9}$/.test(value);
        return isValid ? 'valid' : 'invalid';
      }
      case 'onlyDigits': {
        const onlyDigits = /^\d{1,10}$/.test(value);
        return onlyDigits ? 'valid' : 'invalid';
      }
      default:
        return null;
    }
  }
}
